// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ChevronDownDefault } from '../../../assets/icons/default/arrows/chevron-down.svg?react';
import { ReactComponent as ChevronDownSolid } from '../../../assets/icons/solid/arrows/CHEVRON-DOWN.svg?react';
import { createIcons } from '../../Icon';
const ChevronDownIcon = /* @__PURE__ */ createIcons('ChevronDown', {
    default: ChevronDownDefault,
    solid: ChevronDownSolid
});
ChevronDownIcon.supportedTypes = ['default', 'solid'];
ChevronDownIcon.category = 'arrows';
export default ChevronDownIcon;
